import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ConfigurationService } from '../../../../core/services/ConfigurationService';
import { ConfigurationState } from '../../../../core/store/reducers';
import { GenericValidateResponse, GenericUploadResponse, GenericBulkUpsertField } from '../models/generic-bulk-upsert.model';

@Injectable({
  providedIn: 'root'
})
export class GenericBulkUpsertService {
  constructor(private http: HttpClient, private configuration: ConfigurationService) {}

  validateFile(file: File, endpointUrl: string): Observable<GenericValidateResponse> {
    return this.configuration.config$.pipe(
      switchMap((c: ConfigurationState) => {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post<GenericValidateResponse>(`${c.config.apiServer}${endpointUrl}`, formData);
      })
    );
  }

  uploadFile(file: File, endpointUrl: string): Observable<GenericUploadResponse> {
    return this.configuration.config$.pipe(
      switchMap((c: ConfigurationState) => {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post<GenericUploadResponse>(`${c.config.apiServer}${endpointUrl}`, formData);
      })
    );
  }

  downloadTemplate(fields: GenericBulkUpsertField[], filename: string): void {
    const headers = fields.map(field => field.label).join(',');
    const csvContent = headers + '\n';

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
